import { useState } from "react";
import { useGolfStatsText } from "./GolfPersonalStats";
const scoreKey = (participantId, hole) => `${participantId}:${hole}`;

export default function FullCard({ stats, data, scores, goHole }) {
  const { t } = useGolfStatsText();
  const [mode, setMode] = useState("personal");
  const mine = data.participants.find((p) => p.id === data.myParticipantId);
  const participants = mode === "personal" ? (mine ? [mine] : []) : data.participants;
  const completeCount = data.holes.filter(h =>
    participants.length > 0 && participants.every(p =>
      scores[scoreKey(p.id, h.hole_number)] != null,
    ),
  ).length;
  const missing = (value, label = "unrecorded") =>
    value == null ? <span aria-label={t(label)}>—</span> : value;
  const answer = (value, applicable, yes, no) =>
    applicable == null ? (
      <span aria-label={t("unknownPar")}>—</span>
    ) : !applicable ? (
      <span aria-label={t("na")}>{t("na")}</span>
    ) : value == null ? (
      <span aria-label={t("unrecorded")}>—</span>
    ) : (
      <span
        className={value ? "mp-stat-hit" : "mp-stat-miss"}
        aria-label={t(value ? yes : no)}
      >
        {value ? "✓" : "×"}
      </span>
    );
  return (
    <div className="mp-golf-full-card">
      <div className="mp-golf-card-selector">
        <h2>{t("scorecardHeading")}</h2>
        <select
          aria-label={t("cardView")}
          title={
            mode === "personal"
              ? mine?.display_name || t("personal")
              : t("group")
          }
          value={mode}
          onChange={(event) => setMode(event.target.value)}
        >
          <option value="personal">
            {mine?.display_name || t("personal")}
          </option>
          <option value="group">{t("group")}</option>
        </select>
      </div>
      <div
        className="mp-golf-table-scroll"
        tabIndex={0}
        role="region"
        aria-label={t(mode === "personal" ? "personal" : "group")}
      >
        <table
          className={`mp-golf-score-table ${mode === "group" ? "is-group" : ""}`}
          style={mode === "group" ? {"--group-table-width": `${(data.participants.length + 2) * 68}px`} : undefined}
        >
          <thead>
            <tr>
              <th scope="col">{t("hole")}</th>
              <th scope="col">{t("par")}</th>
              {mode === "personal" ? (
                <>
                  <th scope="col">{t("score")}</th>
                  <th scope="col">{t("putts")}</th>
                  <th scope="col" aria-label={t("fairway")}>FW</th>
                  <th scope="col" aria-label={t("gir")}>GIR</th>
                </>
              ) : (
                data.participants.map((p) => (
                  <th scope="col" key={p.id}>
                    {p.display_name}
                  </th>
                ))
              )}
            </tr>
          </thead>
          <tbody>
            {data.holes.map((h) => {
              const stat = stats[h.hole_number],
                score = mine ? scores[scoreKey(mine.id, h.hole_number)] : null;
              return (
                <tr
                  key={h.hole_number}
                  onClick={(event) => {
                    if (!event.target.closest("button")) goHole(h.hole_number);
                  }}
                  aria-current={
                    h.hole_number === data.round.currentHole
                      ? "step"
                      : undefined
                  }
                >
                  <th scope="row">
                    <button
                      type="button"
                      aria-label={t("goHole", { number: h.hole_number })}
                      onClick={() => goHole(h.hole_number)}
                    >
                      {h.hole_number}
                    </button>
                  </th>
                  <td>{missing(h.statsPar, "unknownPar")}</td>
                  {mode === "personal" ? (
                    <>
                      <td>
                        <strong>{missing(score)}</strong>
                      </td>
                      <td>{missing(stat?.putts)}</td>
                      <td>
                        {answer(
                          stat?.fairway_hit,
                          h.statsPar == null
                            ? null
                            : [4, 5].includes(h.statsPar),
                          "hit",
                          "missed",
                        )}
                      </td>
                      <td>
                        {answer(
                          stat?.gir,
                          h.statsPar == null ? null : true,
                          "yes",
                          "no",
                        )}
                      </td>
                    </>
                  ) : (
                    data.participants.map((p) => (
                      <td key={p.id}>
                        <strong>
                          {missing(scores[scoreKey(p.id, h.hole_number)])}
                        </strong>
                      </td>
                    ))
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="mp-golf-completion-count">{t("scoredCoverage", {count: completeCount, total: data.holes.length})}</p>
    </div>
  );
}
